import React from "react";
import ReactDOMClient from "react-dom/client";
import { LandiingPage } from "./screens/LandiingPage";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<LandiingPage />);
